// extracted by mini-css-extract-plugin
module.exports = {"contactLabel":"start-page-flow-details-page_contactLabel__2Mzax"};